import { Component, OnInit, inject } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';

import { TaasUserService } from './core/services/taas-user-service.service';
import { TaasMenuItem, TaasUserDetails } from 'utimaco-common-ui-angular';
import {
  TaasMainLayoutComponent,
  TaasHiddenVersionInfoComponent,
  TaasToastrComponent,
  TaasInformationBannerComponent,
} from 'utimaco-common-ui-angular';
import { KeycloakService } from 'keycloak-angular';
import { RoleBasedMenuService } from './core/services/menu/role-based-menu.service';
import appPackageJson from '../../package.json';
import commonUiPackageJson from 'utimaco-common-ui-angular/package.json';
import { environment } from '@kmaas-environments/environment';
import { TaasBackendHiddenVersionService } from './core/services/taas-backend-hidden-version.service';
import { TaasOrganizationContextService } from './core/services/organization/taas-organization-context.service';

import { take } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [
    TaasMainLayoutComponent,
    TaasHiddenVersionInfoComponent,
    RouterOutlet,
    TaasToastrComponent,
    TaasInformationBannerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private taasUserService = inject(TaasUserService);
  private router = inject(Router);
  private keycloakService = inject(KeycloakService);
  private taasBackendHiddenVersion = inject(TaasBackendHiddenVersionService);
  private roleBasedMenuService = inject(RoleBasedMenuService);
  private orgContext = inject(TaasOrganizationContextService);

  currentuser: TaasUserDetails = {
    givenName: '',
    familyName: '',
    email: '',
    initials: '',
  };

  activeRoute: string = '/';
  taasMenuItemsKm: TaasMenuItem[] = [];
  commonUiLibVersion: string = commonUiPackageJson.version;
  appVersion: string = appPackageJson.version;
  backendAppVersion!: string;
  protected isTestService: boolean = false;

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //remove locale information if present and remove leading slash
        const cleanedPath = event.urlAfterRedirects.replace(/^\/[a-z]{2}\//, '').replace(/^\/+/, '');
        this.activeRoute = cleanedPath;
      }
    });
    this.taasUserService.getCurrentUserDetails().then((taasUserDetails) => {
      this.currentuser = taasUserDetails;
    });
  }

  ngOnInit() {
    // Track whether to show the Test banner
    this.orgContext.isTestService$.subscribe((flag) => {
      this.isTestService = !!flag;
    });

    // Initial fetch after app init (also happens on first NavigationEnd)
    this.orgContext.refresh().pipe(take(1)).subscribe();

    this.taasBackendHiddenVersion.getBackendVersion().subscribe({
      next: (response) => {
        this.backendAppVersion = response?.body?.['data'];
      },
      error: (error) => {
        console.error($localize`:App Component:Error fetching data:`, error);
      },
    });

    // subscribe to role-based menu items
    this.roleBasedMenuService.menuItems$.subscribe((menuItems) => {
      this.taasMenuItemsKm = menuItems;
    });
  }

  handleRouteUpdateRequest(path: string) {
    this.router.navigateByUrl(path);
  }

  navigateHome() {
    window.open(environment.taasPortalFrontendUrl);
  }

  performLogout() {
    this.orgContext.clearCache();
    this.keycloakService?.logout(window.location.origin);
  }

  handleUserContextMenuEvent(event: string) {
    switch (event) {
      case 'logout':
        this.performLogout();
        break;
      case 'showOwnProfile':
        window.open(environment.taasPortalFrontendUrl + '/en/profile');
        break;
      default:
        break;
    }
  }
}
